import { StyleSheet } from 'react-native';
import React from 'react';
import Typography from '../../typography/Typography';
import { ColorTokens, FontFamilyTokens, FontSizeTokens, TextAlignTokens } from '@voltmoney/schema';
const InfoText = ({ label }) => {
    return (React.createElement(Typography, { label: label, fontSize: FontSizeTokens.XS, fontWeight: '500', fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal, lineHeight: 18, textAlign: TextAlignTokens.center }));
};
export default InfoText;
const styles = StyleSheet.create({
// container:{
//     display:'flex',
//     justifyContent :'center',
//     alignItems : 'center',
//     // backgroundColor : '#F3F5FC',
// },
});
